/* eslint-disable */
import React, { useMemo } from "react";
import { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// MUI
import { Box, Typography, Button, Chip } from "@mui/material";

// OpenLayers
import OlFeature from "ol/Feature";

// Custom
import ModelKomentari from "@/models/komentari";
import FormContent from "@/components/FormContent";
import dataController from "@/lib/dataController";
import useFormController from "@/components/useFormController";
import ThankYouDialog from "@/views/Komentari/ThankYouDialog"

// Context
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";
import DialogContext from "@/ui/DialogContext/DialogContext";

// Types
import { FormControllerProps } from "@/@types/components/formController";
import { DCRecord } from "@/@types/lib/dataController";
import { FormContentMode } from "@/@types/components/formContent";


const dc = new dataController(ModelKomentari);

export type PublicCommentsPaneProps = {
  data: {
    feature: OlFeature,
    record?: DCRecord,
  },
  objekt_type?: string,
  wkt: string,
  onClose: () => void,
  mode?: FormContentMode,
  form?: string,
  pane: number | undefined
}

function PublicCommentsPane(props: PublicCommentsPaneProps) {

  const snackbarContext = useContext(SnackbarContext);
  const dialogContext = useContext(DialogContext);

  const { data, objekt_type, wkt, onClose, mode = "insert", form = "insert-public", pane } = props;

  const [drawMode, setDrawMode] = useState(0) //0 = point, 1 = linestring, 2 = polygon/area

  const memoizedInitialRecord = useMemo(() => (
    mode === "insert" 
      ? { wkt, objekt_type, objekt_id: data?.record?.id } 
      : { ...data?.record, wkt }
  ), [mode, wkt, objekt_type, data?.record?.id]);  

  const { record, validation, dataChanged, fields, subModels, onFieldChange, doInsert, doUpdate, doClose, doRefresh, doClear } =
    useFormController({ 
      dc: dc, 
      mode: mode, 
      form: form, 
      onClose: onClose,
      initialRecord: memoizedInitialRecord
    } as FormControllerProps);

  const handleFieldChange = (value: any, source: string) => {
    if (onFieldChange) {
      onFieldChange(value, source);
    }
  };

  const handleChipClick = (newDrawmode: number) => {
    setDrawMode(newDrawmode);
  }

  const handleSubmit = () => {
    if (doInsert) {
      doInsert().then((result) => {
        if (result.success) {
          // close({ dataChanged: true, action: "insert" });
          dialogContext.showDialog(ThankYouDialog)
          onClose();
        } else if (result.error) {
          const msg = t("error.addRecord") + result.error;
          snackbarContext.showNotification(msg, "error");
        } else if (result.validationPass === false) {
          //do nothing
        }
      })
        .catch((resp) => {
          snackbarContext.showNotification(resp.error, "error");
        });
    }

  }

  const handleCancel = () => {
    onClose();
  }

  const { t } = useTranslation();

  return (
    <Box height={"100%"} width={"100%"} p={2}>
      {/* Header */}
      <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} mt={1}>
        <Typography variant="h6">{t("titles.comment")}</Typography>
      </Box>
      {/* Type buttons */}
      {/* <Box width={"100%"} display={"flex"} flexDirection={"row"} justifyContent={"space-evenly"} mt={2}>
        <Chip onClick={(event) => {
          handleChipClick(0);
        }}
          sx={{
            backgroundColor: drawMode === 0 ? "#ff0000" : null,
            transition: "all 0.3s",
            "&:hover":
            {
              backgroundColor: "#dd0000"
            }
          }}
          component="a" clickable label={t("measure.buttons.point")}></Chip>
        <Chip onClick={(event) => {
          handleChipClick(1);
        }}
          sx={{
            backgroundColor: drawMode === 1 ? "#ff0000" : null,
            transition: "all 0.3s",
            "&:hover":
            {
              backgroundColor: "#dd0000"
            }
          }}
          component="a" clickable label={t("measure.buttons.line")}></Chip>
        <Chip onClick={(event) => {
          handleChipClick(2);
        }}
          sx={{
            backgroundColor: drawMode === 2 ? "#ff0000" : null,
            transition: "all 0.3s",
            "&:hover":
            {
              backgroundColor: "#dd0000"
            }
          }}
          component="a" clickable label={t("measure.buttons.area")}></Chip>
      </Box> */}
      {/* Form */}
      <Box mt={2}>
        {<FormContent
          fieldNames={dc.getFormFieldsNames(form)}
          record={record}
          validation={validation}
          fields={fields}
          mode={mode}
          onFieldChange={handleFieldChange}
        />}
      </Box>
      { mode === "insert" ? 
        <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} mt={1}>
          <Button variant="outlined" onClick={handleCancel}>{t("buttons.cancel")}</Button>
          <Button variant="contained" onClick={handleSubmit}>{t("buttons.send")}</Button>
        </Box>
      : null }
    </Box>
  );
}

export default PublicCommentsPane;